import React, { memo, useEffect, useRef } from "react";
import { classNames, useTranslate } from "helpers";
import { ReactSVG } from "react-svg";
import { VehicleDocumentationSummaryProps } from "./types";

const VehicleDocumentationSummary: React.FC<
    VehicleDocumentationSummaryProps
> = ({ vehicleInfo, stepCurrent }) => {
    const { t } = useTranslate();
    const thisStep = 8;

    const isActive = stepCurrent === thisStep;
    const isCompleted = stepCurrent > thisStep;

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isActive) {
            ref.current?.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest",
            });
        }
    }, [isActive]);

    if (!isActive && !isCompleted)
        return null;

    return (
        <div
            ref={ref}
            className={classNames(
                `
        bg-white rounded-md border border-blue-100 shadow-xl
          w-[280px] h-[260px]
        flex-shrink-0
        snap-start
        transition-all duration-300
        cursor-pointer
        `,
                isActive
                    ? "opacity-100 scale-100 ring-2 ring-blue-500"
                    : "opacity-70 hover:opacity-100 "
            )}
        >
                <div className="p-3 flex justify-between items-center min-h-[52px]">
                <h3 className="text-sm font-semibold text-slate-800">
                    {thisStep + 1}. Dokumentacija
                </h3>

                {isCompleted && (
                    <div className="bg-green-50 border-2 border-green-500 rounded-full p-1">
                        <ReactSVG
                            src="/media/icons/check.svg"
                            className="w-4 h-4 fill-green-500 stroke-green-500"
                        />
                    </div>
                )}
            </div>

            <div className="border-t border-slate-200 pb-4 p-4 space-y-1.5 h-[200px] overflow-y-scroll">
                {vehicleInfo.documentTypesStatus.length > 0 ? (
                    vehicleInfo.documentTypesStatus.map((dt, i) => (
                        <div key={i} className="flex items-center justify-between gap-2 text-sm">
                           
                            <span className={dt.hasDocuments ? "text-slate-700 font-medium" : "text-slate-400"}>
                                {dt.name}
                            </span>
                             {dt.hasDocuments ? (
                                <ReactSVG src="/media/icons/check.svg" className="w-3.5 h-3.5 fill-green-500 stroke-green-500 flex-shrink-0" />
                            ) : (
                                <div className="w-3.5 h-3.5 rounded-full border-2 border-slate-300 flex-shrink-0" />
                            )}
                        </div>
                    ))
                ) : (
                    <p className="text-sm text-slate-400">Nema podataka</p>
                )}
            </div>
        </div>
    );
};

export default memo(VehicleDocumentationSummary);
